var map = {
	"./videos/all-star/hero-vid_cn.mp4": 1285,
	"./videos/all-star/hero-vid_en.mp4": 1286,
	"./videos/artprize/launch-cn.mp4": 1287,
	"./videos/artprize/launch-en.mp4": 1288,
	"./videos/artprize/waterfall.mp4": 1289,
	"./videos/error/animation-video-nikko-poster.jpg": 1290,
	"./videos/error/animation-video-nikko.mp4": 1291,
	"./videos/home/home_cn.jpg": 1292,
	"./videos/home/home_cn.mp4": 1293,
	"./videos/home/home_en.jpg": 1294,
	"./videos/home/home_en.mp4": 1295,
	"./videos/home/home_jp.jpg": 1296,
	"./videos/home/home_jp.mp4": 1297,
	"./videos/insight/insight-52.jpg": 1298,
	"./videos/insight/insight-52.mp4": 1299,
	"./videos/insight/jarom-v2.jpg": 1300,
	"./videos/insight/jarom-v2.mp4": 1301,
	"./videos/ipad/3d/3d-export_cn.jpg": 1302,
	"./videos/ipad/3d/3d-export_cn.mp4": 1303,
	"./videos/ipad/3d/3d-export_cn.webm": 1304,
	"./videos/ipad/3d/3d-export_cn_hevc.mp4": 1305,
	"./videos/ipad/3d/3d-export_en.jpg": 1306,
	"./videos/ipad/3d/3d-export_en.mp4": 1307,
	"./videos/ipad/3d/3d-export_en.webm": 1308,
	"./videos/ipad/3d/3d-export_en_hevc.mp4": 1309,
	"./videos/ipad/3d/3d-export_jp.jpg": 1310,
	"./videos/ipad/3d/3d-export_jp.mp4": 1311,
	"./videos/ipad/3d/3d-export_jp.webm": 1312,
	"./videos/ipad/3d/3d-export_jp_hevc.mp4": 1313,
	"./videos/ipad/3d/3d-model_cn-hevc.mp4": 1314,
	"./videos/ipad/3d/3d-model_cn.jpg": 1315,
	"./videos/ipad/3d/3d-model_cn.mp4": 1316,
	"./videos/ipad/3d/3d-model_cn.webm": 1317,
	"./videos/ipad/3d/3d-model_en-hevc.mp4": 1318,
	"./videos/ipad/3d/3d-model_en.jpg": 1319,
	"./videos/ipad/3d/3d-model_en.mp4": 1320,
	"./videos/ipad/3d/3d-model_en.webm": 1321,
	"./videos/ipad/3d/3d-model_enBU.jpg": 1322,
	"./videos/ipad/3d/3d-model_jp-hevc.mp4": 1323,
	"./videos/ipad/3d/3d-model_jp.jpg": 1324,
	"./videos/ipad/3d/3d-model_jp.mp4": 1325,
	"./videos/ipad/3d/3d-model_jp.webm": 1326,
	"./videos/ipad/3d/3d-transform_cn.jpg": 1327,
	"./videos/ipad/3d/3d-transform_cn.mp4": 1328,
	"./videos/ipad/3d/3d-transform_en.jpg": 1329,
	"./videos/ipad/3d/3d-transform_en.mp4": 1330,
	"./videos/ipad/3d/3d-transform_jp.jpg": 1331,
	"./videos/ipad/3d/3d-transform_jp.mp4": 1332,
	"./videos/ipad/3d/3d_cn.jpg": 1333,
	"./videos/ipad/3d/3d_cn.mp4": 1334,
	"./videos/ipad/3d/3d_en.jpg": 1335,
	"./videos/ipad/3d/3d_en.mp4": 1336,
	"./videos/ipad/3d/3d_jp.jpg": 1337,
	"./videos/ipad/3d/3d_jp.mp4": 1338,
	"./videos/ipad/a11y/audio-feedback_en.jpg": 1339,
	"./videos/ipad/a11y/audio-feedback_en.mp4": 1340,
	"./videos/ipad/a11y/gestures_cn.jpg": 1341,
	"./videos/ipad/a11y/gestures_cn.mp4": 1342,
	"./videos/ipad/a11y/gestures_en.jpg": 1343,
	"./videos/ipad/a11y/gestures_en.mp4": 1344,
	"./videos/ipad/a11y/gestures_jp.jpg": 1345,
	"./videos/ipad/a11y/gestures_jp.mp4": 1346,
	"./videos/ipad/a11y/hero_en.jpg": 1347,
	"./videos/ipad/a11y/hero_en.mp4": 1348,
	"./videos/ipad/color/color-drop_cn.jpg": 1349,
	"./videos/ipad/color/color-drop_cn.mp4": 1350,
	"./videos/ipad/color/color-drop_en.jpg": 1351,
	"./videos/ipad/color/color-drop_en.mp4": 1352,
	"./videos/ipad/color/color-drop_jp.jpg": 1353,
	"./videos/ipad/color/color-drop_jp.mp4": 1354,
	"./videos/ipad/color/color_cn.jpg": 1355,
	"./videos/ipad/color/color_cn.mp4": 1356,
	"./videos/ipad/color/color_en.jpg": 1357,
	"./videos/ipad/color/color_en.mp4": 1358,
	"./videos/ipad/color/color_jp.jpg": 1359,
	"./videos/ipad/color/color_jp.mp4": 1360,
	"./videos/ipad/color/gradient-map_cn.jpg": 1361,
	"./videos/ipad/color/gradient-map_cn.mp4": 1362,
	"./videos/ipad/color/gradient-map_en.jpg": 1363,
	"./videos/ipad/color/gradient-map_en.mp4": 1364,
	"./videos/ipad/color/gradient-map_jp.jpg": 1365,
	"./videos/ipad/color/gradient-map_jp.mp4": 1366,
	"./videos/ipad/cutting-edge/animationassist-cn.jpg": 1367,
	"./videos/ipad/cutting-edge/animationassist-cn.mp4": 1368,
	"./videos/ipad/cutting-edge/animationassist-en.jpg": 1369,
	"./videos/ipad/cutting-edge/animationassist-en.mp4": 1370,
	"./videos/ipad/cutting-edge/animationassist-jp.jpg": 1371,
	"./videos/ipad/cutting-edge/animationassist-jp.mp4": 1372,
	"./videos/ipad/cutting-edge/colordrop-cn.jpg": 1373,
	"./videos/ipad/cutting-edge/colordrop-cn.mp4": 1374,
	"./videos/ipad/cutting-edge/colordrop-en.jpg": 1375,
	"./videos/ipad/cutting-edge/colordrop-en.mp4": 1376,
	"./videos/ipad/cutting-edge/colordrop-jp.jpg": 1377,
	"./videos/ipad/cutting-edge/colordrop-jp.mp4": 1378,
	"./videos/ipad/cutting-edge/freehand-cn.jpg": 1379,
	"./videos/ipad/cutting-edge/freehand-cn.mp4": 1380,
	"./videos/ipad/cutting-edge/freehand-en.jpg": 1381,
	"./videos/ipad/cutting-edge/freehand-en.mp4": 1382,
	"./videos/ipad/cutting-edge/freehand-jp.jpg": 1383,
	"./videos/ipad/cutting-edge/freehand-jp.mp4": 1384,
	"./videos/ipad/cutting-edge/gestures_cn.jpg": 1385,
	"./videos/ipad/cutting-edge/gestures_cn.mp4": 1386,
	"./videos/ipad/cutting-edge/gestures_en.jpg": 1387,
	"./videos/ipad/cutting-edge/gestures_en.mp4": 1388,
	"./videos/ipad/cutting-edge/hero_cn.jpg": 1389,
	"./videos/ipad/cutting-edge/hero_cn.mp4": 1390,
	"./videos/ipad/cutting-edge/hero_en.jpg": 1391,
	"./videos/ipad/cutting-edge/hero_en.mp4": 1392,
	"./videos/ipad/cutting-edge/quickshape-cn.jpg": 1393,
	"./videos/ipad/cutting-edge/quickshape-cn.mp4": 1394,
	"./videos/ipad/cutting-edge/quickshape-en.jpg": 1395,
	"./videos/ipad/cutting-edge/quickshape-en.mp4": 1396,
	"./videos/ipad/cutting-edge/quickshape-jp.jpg": 1397,
	"./videos/ipad/cutting-edge/quickshape-jp.mp4": 1398,
	"./videos/ipad/filters_cn.jpg": 1399,
	"./videos/ipad/filters_cn.mp4": 1400,
	"./videos/ipad/filters_en.jpg": 1401,
	"./videos/ipad/filters_en.mp4": 1402,
	"./videos/ipad/hero_cn.jpg": 1403,
	"./videos/ipad/hero_cn.mp4": 1404,
	"./videos/ipad/hero_en.jpg": 1405,
	"./videos/ipad/hero_en.mp4": 1406,
	"./videos/ipad/hero_jp.jpg": 1407,
	"./videos/ipad/hero_jp.mp4": 1408,
	"./videos/ipad/old/ipad-hero_cn.jpg": 1409,
	"./videos/ipad/old/ipad-hero_cn.mp4": 1410,
	"./videos/ipad/old/ipad-hero_en.jpg": 1411,
	"./videos/ipad/old/ipad-hero_en.mp4": 1412,
	"./videos/ipad/timelapse-video-asuka-poster.jpg": 1413,
	"./videos/ipad/timelapse-video-asuka.mp4": 1414,
	"./videos/ipad/video/animation-video-alexgrigg-poster.jpg": 1415,
	"./videos/ipad/video/animation-video-alexgrigg.mp4": 1416,
	"./videos/ipad/video/timelapse-video-max-poster.jpg": 1417,
	"./videos/ipad/video/timelapse-video-max.mp4": 1418,
	"./videos/ipad/whats-new/3d-painting_cn.jpg": 1419,
	"./videos/ipad/whats-new/3d-painting_cn.mp4": 1420,
	"./videos/ipad/whats-new/3d-painting_en.jpg": 1421,
	"./videos/ipad/whats-new/3d-painting_en.mp4": 1422,
	"./videos/ipad/whats-new/3d-painting_jp.jpg": 1423,
	"./videos/ipad/whats-new/3d-painting_jp.mp4": 1424,
	"./videos/ipad/whats-new/pencil-filters_cn.jpg": 1425,
	"./videos/ipad/whats-new/pencil-filters_cn.mp4": 1426,
	"./videos/ipad/whats-new/pencil-filters_en.jpg": 1427,
	"./videos/ipad/whats-new/pencil-filters_en.mp4": 1428,
	"./videos/ipad/whats-new/whats-new_cn.jpg": 1429,
	"./videos/ipad/whats-new/whats-new_cn.mp4": 1430,
	"./videos/ipad/whats-new/whats-new_en.jpg": 1431,
	"./videos/ipad/whats-new/whats-new_en.mp4": 1432,
	"./videos/ipad/whats-new/whats-new_jp.jpg": 1433,
	"./videos/ipad/whats-new/whats-new_jp.mp4": 1434,
	"./videos/ipad/whats-new/whatsnew-gradientmap_cn.jpg": 1435,
	"./videos/ipad/whats-new/whatsnew-gradientmap_cn.mp4": 1436,
	"./videos/ipad/whats-new/whatsnew-gradientmap_en.jpg": 1437,
	"./videos/ipad/whats-new/whatsnew-gradientmap_en.mp4": 1438,
	"./videos/ipad/whats-new/whatsnew-scribble_cn.jpg": 1439,
	"./videos/ipad/whats-new/whatsnew-scribble_cn.mp4": 1440,
	"./videos/ipad/whats-new/whatsnew-scribble_en.jpg": 1441,
	"./videos/ipad/whats-new/whatsnew-scribble_en.mp4": 1442,
	"./videos/ipad/whats-new/whatsnew-selectioncolorfill_cn.jpg": 1443,
	"./videos/ipad/whats-new/whatsnew-selectioncolorfill_cn.mp4": 1444,
	"./videos/ipad/whats-new/whatsnew-selectioncolorfill_en.jpg": 1445,
	"./videos/ipad/whats-new/whatsnew-selectioncolorfill_en.mp4": 1446,
	"./videos/pocket/cn_animate.mp4": 1447,
	"./videos/pocket/en_animate.mp4": 1448,
	"./videos/pocket/jp_animate.mp4": 1449,
	"./videos/pocket/timelapse_desktop.mp4": 1450,
	"./videos/pocket/timelapse_desktop_poster.jpg": 1451,
	"./videos/pocket/timelapse_mobile.mp4": 1452,
	"./videos/pocket/timelapse_mobile_poster.jpg": 1453
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1284;